var map = {
	"./echo": 386,
	"./echo.ts": 386,
	"./ls": 346,
	"./ls.ts": 346,
	"./mkdir": 16,
	"./mkdir.ts": 16,
	"./rm": 950,
	"./rm.ts": 950,
	"./rmdir": 327,
	"./rmdir.ts": 327,
	"./touch": 476,
	"./touch.ts": 476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 534;